<template>
  <div class="bit-drop" id="million-bit-drop">
    <div id="game-menu">
        <div>
            <span class="btn-group nav-buttons">
            <button type="button" class="btn btn-icon btn-outline-light" v-on:click="navigateTo('/')"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="bi bi-house"><path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z"></path></svg></button>
            <button type="button" class="btn btn-icon btn-outline-light" v-on:click="mute(true)" v-if="!isMuted">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-volume-up-fill" viewBox="0 0 16 16">
                    <path d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"/>
                    <path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"/>
                    <path d="M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06"/>
                </svg>
            </button>
            <button type="button" class="btn btn-icon btn-outline-light" v-on:click="mute(false)" v-if="isMuted">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-volume-mute-fill" viewBox="0 0 16 16">
                    <path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06m7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0"/>
                </svg>
            </button>
            <!-- <button class="btn btn-outline-light" v-on:click="newGame();">New Game</button> -->
            </span>
        </div>
        <div><h1 class="honk-text">Million Base Drop</h1></div>
        <div><h3><span id="score-label">Score</span> <span class="honk-text" v-text="score"></span></h3></div>
    </div>
    <div id="game-frame">
      <div id="game-over" v-if="!isPlaying">
        <h1>Your Score <span class="honk-text" v-text="score"></span></h1>
        <h1>High Score <span class="honk-text" v-text="highscore"></span></h1>

        <div class="bg-danger border text-left p-1 text-center" v-if="isSponsored">
          <span class="">Win Moon Credits by getting on the leaderboard and sharing your score on Twitter X!</span>
          <br />
          <div class="text-justify">
            <a href="https://x.com/BitHomepage/status/1858604087782371539" class="btn btn-sm" target="_blank">Learn more</a>
            <a href="https://x.com/Moon_Credits" class="btn btn-sm float-right" target="_blank">Sponsor <img src="https://millionbithomepage.com/trx/0xe1ce4dc5a815a3d9324947ef8cd6569745e19f76af013442a49b7c9b6eda9c54-crop.jpeg" style="border-radius: 50%; max-height: 16px;" /></a>
          </div>
        </div>

        <a v-bind:href="xPost" target="_blank" class="btn btn-block btn-lg btn-outline-light" v-if="score > 0">Share on X</a>
        <button class="btn btn-block btn-lg btn-warning my-5" v-on:click="newGame();" v-bind:disabled="isLoading">New Game</button>
        <div id="game-leaderboard" class="mt-4">
          <h3 style="text-decoration: underline;">Leaderboard</h3>
          <p v-if="!appData().connectedAccount.address">Join the leaderboard by first connecting your wallet! <br />
            <button type="button" class="btn btn-icon btn-block btn-info mt-5" v-on:click="connectWallet()">
              Connect Wallet
            </button>
          </p>
          <div class="btn-group btn-block">
            <button type="button" class="btn btn-icon btn-block btn-outline-light my-3" v-on:click="toggleLeaderBoard()" v-bind:class="{'disabled': this.leaderBoardToggle === 'all'}">
              This Week
            </button>
            <button type="button" class="btn btn-icon btn-block btn-outline-light my-3" v-on:click="toggleLeaderBoard()" v-bind:class="{'disabled': this.leaderBoardToggle === 'week'}">
              All Time
            </button>
          </div>
          <p v-if="appData().connectedAccount.address">
            Player: 
            <img v-if="appData().connectedAccount.avatar" v-bind:src="appData().connectedAccount.avatar" style="max-height: 22px;" class="ensAvatar">
            <span v-if="appData().connectedAccount.name">{{ appData().connectedAccount.name }}</span>
            <span v-if="!appData().connectedAccount.name">{{ appData().connectedAccount.addressTrunc }}</span>
          </p>
          <table style="width: 100%">
            <tr>
              <th class="text-left"> </th>
              <th class="text-left">Player</th>
              <th class="text-right">Score</th>
            </tr>
            <tr v-if="gameLeaderboard.length === 0">
              <td colspan="3" class="text-center">Loading...</td>
            </tr>
            <tr v-for="(entry, index) in gameLeaderboard" v-bind:key="entry._id">
              <td><h5 class="mr-1 honk-text">{{ index + 1 }}</h5></td>
              <td class="text-left">
                <span v-if="entry.player.avatar">
                  <img v-bind:src="entry.player.avatar" style="max-height: 22px;" class="ensAvatar">
                </span>
                <span v-if="entry.player.name">{{ entry.player.name }}</span>
                <span v-if="!entry.player.name && entry.player.addressTrunc">{{ entry.player.addressTrunc }}</span>
                <span v-if="!entry.player.name && !entry.player.addressTrunc">Anon</span>
              </td>
              <td class="text-right">
                <h4 class="mr-1 honk-text"><span v-if="entry.didWin" class="pr-2">🏆</span>{{ entry.score }}</h4>
              </td>
            </tr>
          </table>
        </div>
      </div>
    <div id="game-canvas">
      <div id="game-ui">
        <p id="game-score"></p>

        <div id="game-end-container">
          <div id="game-end">
            <div id="game-end-title">Game Over!</div>
            <a id="game-end-link" href="">Try Again</a>
          </div>
        </div>

        <div id="game-status">
          <div class="game-status-item">
            <div class="game-status-label">Highscore</div>
            <div id="game-highscore-value">0</div>
          </div>
          <div class="game-status-item">
            <div class="game-status-label">Next</div>
            <img id="game-next-fruit" src="/static/drop/img/circle0.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import utils from '../utils'
const BASE_S3_BUCKET = process.env.BASE_S3_BUCKET;
const LOCAL_STORAGE_DROP_HIGHSCORE_KEY = 'drop_highscore';
const LOCAL_STORAGE_DROP_MUTE_KEY = 'break_muted';
const sfx = {
    bounce: new Audio('/static/bounce.mp3'),
    gameover: new Audio('/static/gameover.mp3'),
    gamestart: new Audio('/static/gamestart.mp3'),
    gamewin: new Audio('/static/gamewin.mp3'),
};

export default {
  name: 'drop',
  data () {
    return {
      isSponsored: false,
      isLoading: true,
      isMuted: false,
      gameLeaderboard: [],
      leaderBoardToggle: 'week',
      s3Base: BASE_S3_BUCKET,
      s3ImgSrc: BASE_S3_BUCKET+'homepage.jpeg?'+Date.now(),
      s3TransactionsJson: BASE_S3_BUCKET+'transactions.json?'+Date.now(),
      score: 0,
      highscore: localStorage.getItem(LOCAL_STORAGE_DROP_HIGHSCORE_KEY) || 0,
      isPlaying: false,
      transactions: [],
    }
  },
  computed: {
    xPost: function() {
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent('🕹️ I just scored ' + this.score + ' on Million Base Drop! Can you beat my score?')}&url=${encodeURIComponent('https://millionbithomepage.com/drop')}`;
    },
  },
  methods: {
    newGame: function() {
      this.playGame();
        this.playSound('gamestart');
    },
    mute: function(doMute) {
      this.isMuted = doMute;
      localStorage.setItem(LOCAL_STORAGE_DROP_MUTE_KEY, this.isMuted);
    },
    toggleLeaderBoard: function() {
        if (this.leaderBoardToggle === 'all') {
            this.leaderBoardToggle = 'week';
        } else {
            this.leaderBoardToggle = 'all';
        }
        this.gameLeaderboard = this.leaderBoardToggle === 'all' ? this.gameLeaderboards.all : this.gameLeaderboards.week;
    },
    playSound: function(sound) {
        if (this.isMuted) {
            return;
        }
        sfx[sound].currentTime = 0;
        sfx[sound].play();
    },
    saveScore: async function(score) {
        const player = this.appData().connectedAccount;
        await this.postToLambda('recordDropScore', {
          score: score,
          player: player,
        });
    },
    endGame: async function(didWin) {
        if (this.isPlaying) {
          this.isPlaying = false;
          if (didWin) {
              this.playSound('gamewin');
              utils.confetti(12000);
          } else {
              this.playSound('gameover');
          }
          if (this.score) {
              await this.saveScore(this.score);
              utils.trackEvent(`dropScore:${this.score}`);
              if (this.score > this.highscore) {
                  this.highscore = this.score;
                  localStorage.setItem(LOCAL_STORAGE_DROP_HIGHSCORE_KEY, this.highscore);
              }
          }
          await this.loadLeaderboard();
          await this.load();
        }
    },
    loadLeaderboard: async function() {
        this.gameLeaderboards = await this.postToLambda('getDropLeaderboard', {});
        this.gameLeaderboard = this.leaderBoardToggle === 'all' ? this.gameLeaderboards.all : this.gameLeaderboards.week;
    },
    playGame: async function() {
      const self = this;
      utils.trackEvent(`playGame:drop`);

      let canvases = document.querySelectorAll('#game-canvas canvas');
      canvases.forEach(canvas => {
        canvas.remove();
      });

      this.isPlaying = true;
      this.score = 0;
      // const Matter = require('matter-js');

function mulberry32(a) {
	return function() {
		let t = a += 0x6D2B79F5;
		t = Math.imul(t ^ t >>> 15, t | 1);
		t ^= t + Math.imul(t ^ t >>> 7, t | 61);
		return ((t ^ t >>> 14) >>> 0) / 4294967296;
	}
}

const rand = mulberry32(Date.now());

const {
	Engine, Render, Runner, Composites, Common, MouseConstraint, Mouse,
	Composite, Bodies, Events,
} = Matter;

const wallPad = 64;
const loseHeight = 84;
const statusBarHeight = 48;
const previewBallHeight = 32;
const friction = {
	friction: 0.006,
	frictionStatic: 0.006,
	frictionAir: 0,
	restitution: 0.1
};

const GameStates = {
	MENU: 0,
	READY: 1,
	DROP: 2,
	LOSE: 3,
};

const Game = {
	width: 640,
	height: 960,
	elements: {
		canvas: document.getElementById('game-canvas'),
		ui: document.getElementById('game-ui'),
		score: document.getElementById('game-score'),
		end: document.getElementById('game-end-container'),
		endTitle: document.getElementById('game-end-title'),
		statusValue: document.getElementById('game-highscore-value'),
		nextFruitImg: document.getElementById('game-next-fruit'),
		previewBall: null,
	},
	cache: { highscore: 0 },
	sounds: {
		click: new Audio('/static/drop/click.mp3'),
		pop0: new Audio('/static/drop/pop0.mp3'),
		pop1: new Audio('/static/drop/pop1.mp3'),
		pop2: new Audio('/static/drop/pop2.mp3'),
		pop3: new Audio('/static/drop/pop3.mp3'),
		pop4: new Audio('/static/drop/pop4.mp3'),
		pop5: new Audio('/static/drop/pop5.mp3'),
		pop6: new Audio('/static/drop/pop6.mp3'),
		pop7: new Audio('/static/drop/pop7.mp3'),
		pop8: new Audio('/static/drop/pop8.mp3'),
		pop9: new Audio('/static/drop/pop9.mp3'),
		pop10: new Audio('/static/drop/pop10.mp3'),
	},

	stateIndex: GameStates.MENU,

	score: 0,
	fruitsMerged: [],
	calculateScore: function () {
		const score = Game.fruitsMerged.reduce((total, count, sizeIndex) => {
			const value = Game.fruitSizes[sizeIndex].scoreValue * count;
			return total + value;
		}, 0);

		Game.score = score;
		Game.elements.score.innerText = Game.score;

    if (Game.score) {
      self.score = Game.score;
    }
	},
    fruitSizes: this.fruitSizes,
	// fruitSizes: [
	// 	{ radius: 24,  scoreValue: 1,  img: '/static/drop/img/circle0.png'  },
	// 	{ radius: 32,  scoreValue: 3,  img: '/static/drop/img/circle1.png'  },
	// 	{ radius: 40,  scoreValue: 6,  img: '/static/drop/img/circle2.png'  },
	// 	{ radius: 56,  scoreValue: 10, img: '/static/drop/img/circle3.png'  },
	// 	{ radius: 64,  scoreValue: 15, img: '/static/drop/img/circle4.png'  },
	// 	{ radius: 72,  scoreValue: 21, img: '/static/drop/img/circle5.png'  },
	// 	{ radius: 84,  scoreValue: 28, img: '/static/drop/img/circle6.png'  },
	// 	{ radius: 96,  scoreValue: 36, img: '/static/drop/img/circle7.png'  },
	// 	{ radius: 128, scoreValue: 45, img: '/static/drop/img/circle8.png'  },
	// 	{ radius: 160, scoreValue: 55, img: '/static/drop/img/circle9.png'  },
	// 	{ radius: 192, scoreValue: 66, img: '/static/drop/img/circle10.png' },
	// ],
	currentFruitSize: 0,
	nextFruitSize: 0,
	setNextFruitSize: function () {
		Game.nextFruitSize = Math.floor(rand() * 5);
		Game.elements.nextFruitImg.src = this.fruitSizes[Game.nextFruitSize].img;
	},

	// showHighscore: function () {
	// 	Game.elements.statusValue.innerText = Game.cache.highscore;
	// },
	// loadHighscore: function () {
	// 	const gameCache = localStorage.getItem('suika-game-cache');
	// 	if (gameCache === null) {
	// 		Game.saveHighscore();
	// 		return;
	// 	}

	// 	Game.cache = JSON.parse(gameCache);
	// 	Game.showHighscore();
	// },
	// saveHighscore: function () {
	// 	Game.calculateScore();
	// 	if (Game.score < Game.cache.highscore) return;

	// 	Game.cache.highscore = Game.score;
	// 	Game.showHighscore();
	// 	Game.elements.endTitle.innerText = 'New Highscore!';

	// 	localStorage.setItem('suika-game-cache', JSON.stringify(Game.cache));
	// },

	initGame: function () {
		Render.run(render);
		Runner.run(runner, engine);

		Composite.add(engine.world, menuStatics);

		// Game.loadHighscore();
		Game.elements.ui.style.display = 'none';
		Game.fruitsMerged = Array.apply(null, Array(Game.fruitSizes.length)).map(() => 0);

		const menuMouseDown = function () {
			if (mouseConstraint.body === null || !mouseConstraint.body || mouseConstraint.body.label !== 'btn-start') {
				return;
			}

			Events.off(mouseConstraint, 'mousedown', menuMouseDown);
			Game.startGame();
		}

		Events.on(mouseConstraint, 'mousedown', menuMouseDown);
	},

	startGame: function () {
    if (!self.isMuted) {
		  Game.sounds.click.play();
    }

		Composite.remove(engine.world, menuStatics);
		Composite.add(engine.world, gameStatics);

		Game.calculateScore();
		Game.elements.endTitle.innerText = 'Game Over!';
		Game.elements.ui.style.display = 'block';
		Game.elements.end.style.display = 'none';
		Game.elements.previewBall = Game.generateFruitBody(Game.width / 2, previewBallHeight, 0, { isStatic: true });
		Composite.add(engine.world, Game.elements.previewBall);

		setTimeout(() => {
			Game.stateIndex = GameStates.READY;
		}, 250);

		Events.on(mouseConstraint, 'mouseup', function (e) {
			Game.addFruit(e.mouse.position.x);
		});

		Events.on(mouseConstraint, 'mousemove', function (e) {
			if (Game.stateIndex !== GameStates.READY) return;
			if (Game.elements.previewBall === null) return;

			Game.elements.previewBall.position.x = e.mouse.position.x;
		});

		Events.on(engine, 'collisionStart', function (e) {
			for (let i = 0; i < e.pairs.length; i++) {
				const { bodyA, bodyB } = e.pairs[i];

				// Skip if collision is wall
				if (bodyA.isStatic || bodyB.isStatic) continue;

				const aY = bodyA.position.y + bodyA.circleRadius;
				const bY = bodyB.position.y + bodyB.circleRadius;

				// Uh oh, too high!
				if (aY < loseHeight || bY < loseHeight) {
					Game.loseGame();
					return;
				}

				// Skip different sizes
				if (bodyA.sizeIndex !== bodyB.sizeIndex) continue;

				// Skip if already popped
				if (bodyA.popped || bodyB.popped) continue;

				let newSize = bodyA.sizeIndex + 1;

				// Go back to smallest size
				if (bodyA.circleRadius >= Game.fruitSizes[Game.fruitSizes.length - 1].radius) {
					newSize = 0;
				}

				Game.fruitsMerged[bodyA.sizeIndex] += 1;

				// Therefore, circles are same size, so merge them.
				const midPosX = (bodyA.position.x + bodyB.position.x) / 2;
				const midPosY = (bodyA.position.y + bodyB.position.y) / 2;

				bodyA.popped = true;
				bodyB.popped = true;

        if (!self.isMuted) {
				  Game.sounds[`pop${bodyA.sizeIndex}`].play();
        }
				Composite.remove(engine.world, [bodyA, bodyB]);
				Composite.add(engine.world, Game.generateFruitBody(midPosX, midPosY, newSize));
				Game.addPop(midPosX, midPosY, bodyA.circleRadius);
				Game.calculateScore();
			}
		});
	},

	addPop: function (x, y, r) {
		const circle = Bodies.circle(x, y, r, {
			isStatic: true,
			collisionFilter: { mask: 0x0040 },
			angle: rand() * (Math.PI * 2),
			render: {
				sprite: {
					texture: '/static/drop/img/pop.png',
					xScale: r / 384,
					yScale: r / 384,
				}
			},
		});

		Composite.add(engine.world, circle);
		setTimeout(() => {
			Composite.remove(engine.world, circle);
		}, 100);
	},

	loseGame: function () {
		Game.stateIndex = GameStates.LOSE;
		// Game.elements.end.style.display = 'flex';
		runner.enabled = false;
		// Game.saveHighscore();

    self.endGame();
	},

	// Returns an index, or null
	lookupFruitIndex: function (radius) {
		const sizeIndex = Game.fruitSizes.findIndex(size => size.radius == radius);
		if (sizeIndex === undefined) return null;
		if (sizeIndex === Game.fruitSizes.length - 1) return null;

		return sizeIndex;
	},

	generateFruitBody: function (x, y, sizeIndex, extraConfig = {}) {
		const size = Game.fruitSizes[sizeIndex];
		const circle = Bodies.circle(x, y, size.radius, {
			...friction,
			...extraConfig,
      label: 'fruit',
			render: {
        sprite: {
          texture: size.img,
          xScale: size.radius / Math.min(size.h, size.w),
          yScale: size.radius / Math.min(size.h, size.w),
        }
      },
		});
		circle.sizeIndex = sizeIndex;
		circle.popped = false;

		return circle;
	},

	addFruit: function (x) {
		if (Game.stateIndex !== GameStates.READY) return;

    if (!self.isMuted) {
		  Game.sounds.click.play();
    }

		Game.stateIndex = GameStates.DROP;
		const latestFruit = Game.generateFruitBody(x, previewBallHeight, Game.currentFruitSize);
		Composite.add(engine.world, latestFruit);

		Game.currentFruitSize = Game.nextFruitSize;
		Game.setNextFruitSize();
		Game.calculateScore();

		Composite.remove(engine.world, Game.elements.previewBall);
		Game.elements.previewBall = Game.generateFruitBody(render.mouse.position.x, previewBallHeight, Game.currentFruitSize, {
			isStatic: true,
			collisionFilter: { mask: 0x0040 }
		});

		setTimeout(() => {
			if (Game.stateIndex === GameStates.DROP) {
				Composite.add(engine.world, Game.elements.previewBall);
				Game.stateIndex = GameStates.READY;
			}
		}, 500);
	}
}

const engine = Engine.create();
const runner = Runner.create();
const render = Render.create({
	element: Game.elements.canvas,
	engine,
	options: {
		width: Game.width,
		height: Game.height,
		wireframes: false,
		background: 'transparent',

    // showDebug: true,
    // showBroadphase: false,
    // showBounds: true,
    // showVelocity: false,
    // showCollisions: false,
    // showSeparations: false,
    // showAxes: false,
    // showPositions: true,
    // showAngleIndicator: false,
    // showIds: true,
    // showShadows: false,
    // showVertexNumbers: false,
    // showConvexHulls: false,
    // showInternalEdges: false,
    // showMousePosition: false
	}
});

const menuStatics = [
	Bodies.rectangle(Game.width / 2, Game.height * 0.4, 512, 512, {
		isStatic: true,
		render: { sprite: { texture: '/static/drop/img/bg-menu.png' } },
	}),

	// Add each fruit in a circle
	...Array.apply(null, Array(Game.fruitSizes.length)).map((_, index) => {
		const x = (Game.width / 2) + 192 * Math.cos((Math.PI * 2 * index)/12);
		const y = (Game.height * 0.4) + 192 * Math.sin((Math.PI * 2 * index)/12);
		const r = 64;

		return Bodies.circle(x, y, r, {
			isStatic: true,
			render: {
				sprite: {
					texture: this.fruitSizes[index].img,
					xScale: r / 2 / Math.min(this.fruitSizes[index].w, this.fruitSizes[index].h), // (this.fruitSizes[index].w * (this.fruitSizes[index].h / this.fruitSizes[index].w)),
					yScale: r / 2 / Math.min(this.fruitSizes[index].w, this.fruitSizes[index].h), //(this.fruitSizes[index].h * (this.fruitSizes[index].w / this.fruitSizes[index].h)),
				},
			},
		});
	}),

	Bodies.rectangle(Game.width / 2, Game.height * 0.75, 512, 96, {
		isStatic: true,
		label: 'btn-start',
		render: { sprite: { texture: '/static/drop/img/btn-start.png' } },
	}),
];

const wallProps = {
	isStatic: true,
	render: { fillStyle: '#0063cd' },
	...friction,
};

const gameStatics = [
  // Render BG with grid pattern
  Bodies.rectangle(Game.width / 2, (Game.height / 2) + loseHeight, Game.width, Game.height, {
		isStatic: true,
		label: 'bg',
  render: { sprite: { texture: '/static/drop/img/grid.jpeg' } },
    collisionFilter: {
    category: 0x0001, // This is an arbitrary category not used by other objects
    mask: 0, // Prevents any collision
  }
	}),
	// Left
	Bodies.rectangle(-(wallPad / 2), Game.height / 2, wallPad, Game.height, wallProps),

	// Right
	Bodies.rectangle(Game.width + (wallPad / 2), Game.height / 2, wallPad, Game.height, wallProps),

	// Bottom
	Bodies.rectangle(Game.width / 2, Game.height + (wallPad / 2) - statusBarHeight, Game.width, wallPad, wallProps),
];

// add mouse control
const mouse = Mouse.create(render.canvas);
const mouseConstraint = MouseConstraint.create(engine, {
	mouse: mouse,
	constraint: {
		stiffness: 0.2,
		render: {
			visible: false,
		},
	},
});
render.mouse = mouse;

Game.initGame();

const resizeCanvas = () => {
    // console.log(`resizeCanvas`);
	const screenWidth = document.body.clientWidth; // window.innerWidth
  const gameMenu = document.getElementById('game-menu');
	const screenHeight = window.innerHeight - gameMenu.offsetHeight - 0; // document.body.clientHeight

  let newWidth = Game.width;
	let newHeight = Game.height;
	let scaleUI = 1;

	if (screenWidth * 1.5 > screenHeight) {
		newHeight = Math.min(Game.height, screenHeight);
		newWidth = newHeight / 1.5;
		scaleUI = newHeight / Game.height;
	} else {
		newWidth = Math.min(Game.width, screenWidth);
		newHeight = newWidth * 1.5;
		scaleUI = newWidth / Game.width;
	}
  // console.log(`screenWidth: ${screenWidth}, screenHeight: ${screenHeight}, newWidth: ${newWidth}, newHeight: ${newHeight}, scaleUI: ${scaleUI}`);

	// render.canvas.style.width = `${newWidth}px`;
	// render.canvas.style.height = `${newHeight}px`;

	Game.elements.ui.style.width = `${Game.width}px`;
	Game.elements.ui.style.height = `${Game.height}px`;
	Game.elements.ui.style.transform = `scale(${scaleUI})`;

    // paintGrid(render.canvas);
};

this.resizeCanvas = resizeCanvas;

resizeCanvas();
// document.body.onresize = resizeCanvas;
window.addEventListener('resize', this.resizeCanvas); // Add resize event listener
    },
    ensureImageLoaded: async function(img) {
      return new Promise((resolve, reject) => {
          if (img.complete) {
              resolve();
          } else {
              img.onload = resolve;
              img.onerror = reject;
          }
      });
    },
    navigateTo: function(route) {
      this.$router.push(route);
    },
    load: async function() {
      this.isLoading = true;
        try {
            const response = await axios.get(this.s3TransactionsJson);
            this.transactions = response.data;
        } catch (e) {
            console.error('Error fetching link map', e);
        }
        // console.log(this.transactions);
        this.plotSizes = {
            smallest: this.transactions.filter(t => t.pixels <= 256),
            small: this.transactions.filter(t => t.pixels > 256 && t.pixels <= 1024),
            medium: this.transactions.filter(t => t.pixels > 1024 && t.pixels <= 2304),
            large: this.transactions.filter(t => t.pixels > 2304),
        }
        const getRandomPlot = (size, tokenId) => {
            const plots = this.plotSizes[size];
            let plot;
            if (tokenId) {
              plot = plots.find(t => t.tokenId === tokenId);
              if (!plot) {
                return getRandomPlot(size);
              }
            } else {
              // Pick a random plot
              plot = plots[Math.floor(Math.random() * plots.length)];
            }
            // Remove it from the list
            // console.log(`getRandomPlot: ${size}, tokenId: ${tokenId}, plot: ${plot}`);
            this.plotSizes[size] = this.plotSizes[size].filter(t => t.hash !== plot.hash);
            return plot;
        }
        const getPlotUrl = (plot, r) => {
          return new Promise((resolve, reject) => {
            const imgUrl = `https://millionbithomepage.com/trx/${plot.hash}-crop.jpeg`;
            // Load the image and round it into a circle, resulting in a data URL
            const img = new Image();
            img.crossOrigin = 'anonymous'; // Ensure cross-origin friendly loading
            img.src = imgUrl;

            img.onload = function() {
              // console.log('loaded', imgUrl);
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = r * 2;
              canvas.height = r * 2;

              // Calculate dimensions for cropping
              const cropSize = Math.min(img.width, img.height); // Use the smaller dimension
              const cropX = (img.width - cropSize) / 2; // Center crop
              const cropY = (img.height - cropSize) / 2; // Center crop

              // Create a circular clipping path
              ctx.beginPath();
              ctx.arc(r, r, r, 0, 2 * Math.PI);
              ctx.closePath();
              ctx.clip();

              // Draw the cropped image centered in the circular area
              ctx.drawImage(img, cropX, cropY, cropSize, cropSize, 0, 0, r * 2, r * 2);

              // Get the data URL from the canvas
              const dataURL = canvas.toDataURL();
              // console.log(dataURL);

              resolve(dataURL);
            }
          });
        }
        const getPlotFruit = async (radius, scoreValue, size, tokenId) => {
          const plot = getRandomPlot(size, tokenId);
          if (!plot.x2) {
            // return getPlotFruit(size);
            plot.x1 = 0;
            plot.y1 = 0;
            if (plot.pixels == 256) {
              plot.x2 = 256;
              plot.y2 = 256;
            } else if (plot.pixels == 1024) {
              plot.x2 = 1024;
              plot.y2 = 1024;
            } else if (plot.pixels == 2304) {
              plot.x2 = 2304;
              plot.y2 = 2304;
            } else if (plot.pixels == 4096) {
              plot.x2 = 4096;
              plot.y2 = 4096;
            } else {
              return getPlotFruit(radius, scoreValue, size);
            }
          }
          const width = plot.x2 - plot.x1;
          const height = plot.y2 - plot.y1;
          // if (size === 'medium' && width === height) {
          //   // return getPlotFruit(size);
          //   return getPlotFruit(radius, scoreValue, size);
          // }
          const img = await getPlotUrl(plot, Math.min(width, height));

          // Insert img to body // debug preview
          // const imgEl = document.createElement('img');
          // imgEl.src = img;
          // document.body.appendChild(imgEl);

          return {
            radius: radius,
            scoreValue: scoreValue,
            img: img,
            w: plot.x2 - plot.x1,
            h: plot.y2 - plot.y1,
          };
        }
        
        this.fruitSizes = [
            // { radius: 16,  scoreValue: 1,  img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1 },
            // { radius: 32,  scoreValue: 3,  img: await getPlotUrl(getRandomPlot('small')), scale: 0.1  },
            // { radius: 40,  scoreValue: 6,  img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
            // { radius: 56,  scoreValue: 2, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
            // { radius: 64,  scoreValue: 15, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
            // { radius: 72,  scoreValue: 21, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
            // { radius: 84,  scoreValue: 28, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
            // { radius: 96,  scoreValue: 36, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
            // { radius: 128, scoreValue: 45, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
            // { radius: 160, scoreValue: 55, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1  },
            // { radius: 192, scoreValue: 66, img: await getPlotUrl(getRandomPlot('smallest')), scale: 0.1 },
        ];

        this.fruitSizes.push(await getPlotFruit(16, 1, 'smallest'));
        this.fruitSizes.push(await getPlotFruit(32, 3, 'small'));
        this.fruitSizes.push(await getPlotFruit(40, 6, 'small'));
        this.fruitSizes.push(await getPlotFruit(56, 12, 'medium'));
        this.fruitSizes.push(await getPlotFruit(64, 15, 'medium'));
        this.fruitSizes.push(await getPlotFruit(72, 21, 'medium'));
        this.fruitSizes.push(await getPlotFruit(84, 28, 'medium'));
        this.fruitSizes.push(await getPlotFruit(96, 36, 'large'));
        this.fruitSizes.push(await getPlotFruit(128, 45, 'large'));
        this.fruitSizes.push(await getPlotFruit(160, 55, 'large'));
        this.fruitSizes.push(await getPlotFruit(192, 66, 'large'));

        this.isLoading = false;
    },
  },
  mounted: async function () {
    const Matter = await import('matter-js');
    window.Matter = Matter;
    await this.load();
    // this.playGame();
    this.loadLeaderboard();
  },
  inject: ['updateAppRoute', 'appData', 'postToLambda', 'connectWallet'],
  created: function () {
    this.updateAppRoute('drop');
    const isMuted = localStorage.getItem(LOCAL_STORAGE_DROP_MUTE_KEY);
    this.isMuted = isMuted === 'true';
  },
  beforeDestroy() {
    // this.endGame();
    window.removeEventListener('resize', this.resizeCanvas);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #million-bit-drop {
      background: #ffffff !important;
    }
    #million-bit-drop canvas { background: #fff; display: block; margin: 0 auto; }

    /* Row of 3 justified columns */
    #game-menu { display: flex; justify-content: center; height: 60px; width: 100%;
      background-color: #0063cd !important;
      color: #ffffff;
    }

    /* Row columns */
    #game-menu div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 33.3333%;
      height: 100%;
      cursor: pointer;
    }
    #score-label {
      font-family: "DM Sans", sans-serif;
    }
    #game-frame {
      position: relative;
    }
    #game-over {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      min-width: 400px;
      max-width: 800px;
      border-radius: 10px;
      border: 10px solid #002b59;
      padding: 20px;
      margin: 15px auto;
      background-color: #0063cd !important;
      color: #d5d5d5;
      z-index: 2;
    }

    /* :root {
      --col-bg: #FFD59D;
      --col-bg-light: #FFDCAE;
      --col-bg-lighter: #FFEEDB;
      --col-primary: #FF5300;
      --col-primary-dark: #FF2700;
      --col-primary-light: #FF8800;
      --col-shadow: rgba(0, 0, 0, 0.25);
      --col-white: #fff;
    } */

    /* * {
      box-sizing: border-box;
      padding: 0;
      margin: 0;
      line-height: 1;
    } */

    body {
      background-color: var(--col-bg);
      font-family: 'Azeret Mono', sans-serif;
    }

    .container {
      width: 100%;
      max-width: 640px;
      margin: 0 auto;
      height: 100vh;
    }

    #game-canvas {
      position: relative;
    }

    #game-ui {
      position: absolute;
      width: 100%;
      height: 100%;
      pointer-events: none;
      user-select: none;
      font-weight: 700;
      display: none !important;
      transform-origin: top left;
    }

    #game-score {
      position: absolute;
      width: 100%;
      border-bottom: 2px dotted #333;
      font-size: 84px;
      font-weight: 900;
      padding-left: 16px;
      color: var(--col-bg-lighter);
      text-shadow: 3px 3px 0 var(--col-primary), -3px -3px 0 var(--col-primary), -3px 3px 0 var(--col-primary), 3px -3px 0 var(--col-primary);
    }

    #game-end-container {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-items: center;
      background-color: var(--col-shadow);
    }

    #game-end {
      text-align: center;
      padding: 32px 48px;
      background-color: var(--col-bg-lighter);
      border: 5px solid var(--col-primary);
      box-shadow: 0 4px 32px var(--col-shadow);
      border-radius: 32px;
      margin: 0 auto;
      pointer-events: initial;
      user-select: initial;
    }

    #game-end-title {
      font-weight: 700;
      font-size: 48px;
      color: var(--col-primary-dark);
    }

    #game-end-link {
      display: inline-block;
      color: var(--col-white);
      font-size: 24px;
      text-decoration: none;
      background-color: var(--col-primary-light);
      margin-top: 16px;
      padding: 16px;
      border-radius: 16px;
      box-shadow: 4px 4px 0 var(--col-shadow);
    }

    #game-end-link:hover {
      background-color: var(--col-primary);
      box-shadow: 6px 6px 0 var(--col-shadow);
    }

    #game-status {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 48px;
      background-color: var(--col-bg-lighter);
      display: flex;
    }

    .game-status-item {
      display: flex;
      line-height: 1;
      align-items: center;
      margin-right: 32px;
    }

    .game-status-label {
      color: #666;
      font-size: 16px;
      margin-left: 24px;
      margin-right: 8px;
    }

    #game-highscore-value {
      color: #333;
      font-weight: 700;
      font-size: 24px;
    }

    #game-next-fruit {
      width: 24px;
      height: 24px;
    }

    #game-leaderboard h4.honk-text {
      font-size: 3rem;
    }
</style>
<style>
    /* For mobile screens set canvas width to 100% */
    @media screen and (max-device-width: 1024px) {
      #million-bit-drop canvas {
        width: calc(100vw);
      }
      #million-bit-drop #game-menu {
        height: 92px !important;
      }
    }
</style> 


// WEBPACK FOOTER //
// src/components/Drop.vue?83affab2